import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import { message } from 'antd'
import { ImDfmStateType } from '@Admin/AdminQuotingPage/ImDfmSlidesPanel/ImDfmSlide/constants'
import { SLIDE_QUERY_PARAM } from '@Admin/AdminQuotingPage/constants'

import Button from '~/core/Button'
import { useExtractUrlSearchParams } from '~/lib/extractUrlSearchParams'
import logger from '~/lib/logger'
import { DFM_STATUS_ACTIONS } from '../constants'

import acceptImDfmMutation from './acceptImDfmMutation'

interface PrimaryActionButtonPropsType {
    status: ImDfmStateType
    disabled?: boolean
}

const PrimaryActionButton = (props: PrimaryActionButtonPropsType) => {
    const { status, disabled } = props
    const { search } = useLocation()
    const searchParams = useExtractUrlSearchParams(search, [SLIDE_QUERY_PARAM])

    const [acceptImDfm] = useMutation(acceptImDfmMutation)

    const [isLoading, setIsLoading] = useState<boolean>(false)

    const dfmFeedbackId = searchParams[SLIDE_QUERY_PARAM]
    const buttonTxt = DFM_STATUS_ACTIONS[status]?.buttonTxt

    if (!status || !buttonTxt) {
        return null
    }

    const onClick = async () => {
        try {
            setIsLoading(true)

            if (dfmFeedbackId) {
                await acceptImDfm({
                    variables: { dfmFeedbackId },
                })
            } else {
                throw new Error('Missing variable dfmFeedbackId')
            }
        } catch (err) {
            message.error(`${buttonTxt} failed, please refresh and try again.`)
            logger.exception(err, {
                info: 'ImDfmModal/SlideActionPanel/PrimaryActionButton::Failed on acceptDfmFeedback mutation',
                dfmFeedbackId,
                dfmFeedbackStatus: status,
            })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Button
            name={buttonTxt.replace(/\s/g, '-').toLowerCase()}
            loading={isLoading}
            disabled={disabled}
            onClick={onClick}
            placement="im-dfm-slide-action-panel"
            style={{ fontWeight: 500 }}
            type="primary"
        >
            {buttonTxt}
        </Button>
    )
}

export default PrimaryActionButton
